import $ from 'jquery';

function showBodyBlock () {
	
	setTimeout(function () {

		$('.body_group, .hero, .news .heading, .news .grid .cell, .article, .page-article .heading').each(function (index){
			$(this).css('transform', 'translateY(0)');
			$(this).css('opacity', '1');
			$(this).css('transition-delay', 0.1*index + 's' );
	
			// transform: translateY(0);
			// 	opacity: 1;
			// 	transition-delay: #{0.5 * $i}s;
		});

	}, 100);
}

export default showBodyBlock;


// WEBPACK FOOTER //
// ./source/scripts/showBody.js